import { useEffect } from 'react'
import { Button } from 'react-bootstrap'


//HorizontalMulti2Router
import HorizontalMulti2Router from '../../router/horizontal-multi-2-router'

//herder
import HeaderStyle4 from '../../components/partials/dashboard/HeaderStyle/header-style-4'


//footer
import Footer from '../../components/partials/dashboard/FooterStyle/footer'
import { Fragment } from 'react';
import SettingOffCanvas from '../../components/setting/SettingOffCanvas'
import { memo } from 'react';


const DualCompact = memo((props) => {

  useEffect(() => {
    document.body.classList.add('dual-compact')
      return () =>{
        document.body.classList.remove('dual-compact')
      }
  })
  return (
    <Fragment>
      <span className="screen-darken"></span>
      <div id="loading">
      </div>
      <main className="main-content">
        <HeaderStyle4 />
        <div className="conatiner-fluid content-inner">
          <HorizontalMulti2Router />
        </div>
        
        <Footer />
      </main>
      <SettingOffCanvas/>
    </Fragment>
  )
})

export default DualCompact
